// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1e815497","703":"85a4fe8e","787":"2ab827d3"}[chunkId] + ".chunk.js";
};